import script from "./TheTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTitle.vue?vue&type=script&setup=true&lang=js"

import "./TheTitle.vue?vue&type=style&index=0&id=7a2b8ca5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2b8ca5"]])

export default __exports__